import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';

import { showAlert } from '../../store/ducks/alert';
import { getInvoicesData, getInvoicesDataBySearch } from '../../services/invoices';
import { CloudArrowDownIcon } from '@stash-ui/regular-icons';

import { CircularProgress } from '@material-ui/core';

const Invoices = ({ location, match }) => {
  const dispatch = useDispatch();
  const [invoices, setInvoices] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });

  useEffect(() => {
    getInvoices();
  }, []);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    getInvoices(currentPage);
  }, [isSearching, page]);

  useEffect(() => {
    document.addEventListener('keydown', escape, false);

    return () => {
      document.removeEventListener('keydown', escape, false);
    };
  }, []);

  const handleSubmitSearch = searchBox => {
    if (searchBox.search === 'zoop') {
      searchBox.search = 2;
    } else if (searchBox.search === 'iugu') {
      searchBox.search = 3;
    }

    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const escape = useCallback(event => {
    if (event.keyCode === 27) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
      window.history.pushState({ searching: true }, 'Searching', '/' + window.location.href.split('/')[3]);
    }
  }, []);

  const getInvoices = async currentPage => {
    try {
      setIsLoading(true);
      let invoicesData;

      if (isSearching) {
        const { data } = await getInvoicesDataBySearch(searchField.searchItem, searchField.search);
        invoicesData = data;
      } else if (!isSearching && Object.keys(match.params).length === 0) {
        const { data } = await getInvoicesData(currentPage || page);
        invoicesData = data;
      }

      setInvoices(invoicesData.rows);
      setTotalItems(invoicesData.count);
      setTotalPages(invoicesData.pages);
      setPage(invoicesData.page);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      dispatch(showAlert('error', 'Something went wrong'));
    }
  };

  const headers = ['id', 'paidSaasId', 'invoiceToken', 'urlNfe', 'createdAt', 'deletedAt'];

  const SearchBoxHeaders = ['id', 'paidSaasId', 'invoiceToken'];

  const customActions = [
    {
      icon: <CloudArrowDownIcon />,
      action: item => {
        window.open(item.urlNfe, '_blank');
      },
    },
  ];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Invoices ({totalItems})</h1>
        <SearchBox selectItems={SearchBoxHeaders} onSubmitSearch={handleSubmitSearch} isSearching={isSearching} onKeyDown={escape} />
      </div>
      <DataTable
        head={headers}
        body={invoices}
        action
        customActions={customActions}
        bodyColumn={headers}
        linkPath={'invoices'}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
      />
    </>
  );
};

export default Invoices;
